// Footer.js
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faXTwitter, faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import packageJson from '../../package.json';

const { version } = packageJson;
const { name } = packageJson;
const currentYear = new Date().getFullYear();

function Footer() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => { setMounted(true); }, []);

  const socials = [
    { href: 'https://www.facebook.com/chafleks', icon: faFacebook, label: 'Facebook profile' },
    { href: 'https://www.instagram.com/adynetro/', icon: faInstagram, label: 'Instagram profile' },
    { href: 'https://twitter.com/ChAFleks', icon: faXTwitter, label: 'X (Twitter) profile' },
    { href: 'https://www.linkedin.com/in/chafleks/', icon: faLinkedin, label: 'LinkedIn profile' },
    { href: 'https://github.com/adynetro', icon: faGithub, label: 'GitHub profile' },
  ];

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-50 bg-gradient-to-b from-transparent via-black/80 to-black">
      <div className="max-w-site mx-auto flex items-center justify-between px-6 py-3 text-xs text-gray-medium">
        <p className="m-0 p-0">© {currentYear} {name} · v{version}</p>
        <div className="flex items-center gap-2">
          {socials.map((s, i) => (
            <a key={i} href={s.href} target='_blank' rel='noopener noreferrer' aria-label={s.label}
              className={`w-7 h-7 rounded-full bg-white/5 border border-white/10 flex items-center justify-center text-gray-medium hover:text-gold hover:border-gold/30 transition-all duration-200 stagger-item ${mounted ? 'revealed' : ''}`}
              style={{ animationDelay: `${(i + 1) * 100 + 300}ms` }}
            >
              <FontAwesomeIcon icon={s.icon} size="xs" />
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;